import { cn } from "@/utils/cn";
import { toChoiceOption } from "@/types/offer";
import type { SingleChoiceStep as SingleChoiceStepConfig } from "@/types/offer";
import type { StepRenderProps } from "./types";

const KEYS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function SingleChoiceStep({
  step,
  value,
  onChange,
  onAdvance,
}: StepRenderProps<SingleChoiceStepConfig>) {
  const selected = typeof value === "string" ? value : "";
  const autoAdvance = step.autoAdvance ?? true;

  const choose = (next: string) => {
    onChange(next);
    if (autoAdvance) {
      // Brief pause so the selection is visible before transitioning.
      window.setTimeout(() => onAdvance(), 220);
    }
  };

  return (
    <div role="radiogroup" aria-label={step.title} className="flex flex-col gap-3">
      {step.options.map((opt, i) => {
        const o = toChoiceOption(opt);
        const isSelected = selected === o.value;
        return (
          <button
            type="button"
            key={o.value}
            role="radio"
            aria-checked={isSelected}
            className={cn("r1-choice", isSelected && "r1-choice-selected")}
            onClick={() => choose(o.value)}
          >
            <span className="r1-choice-key" aria-hidden="true">
              {KEYS[i] ?? "•"}
            </span>
            <span className="flex flex-col">
              <span className="font-medium">{o.label ?? o.value}</span>
              {o.description ? (
                <span className="text-sm text-ink-muted">{o.description}</span>
              ) : null}
            </span>
          </button>
        );
      })}
    </div>
  );
}
